module.exports = __webpack_public_path__ + "static/img/piglet3.8ea22a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/piglet3.png
// module id = PEYu
// module chunks = 2